import React, { Component } from 'react'
import { Row, Col, Table, Spin, Modal, Button, Popconfirm } from 'antd'
import { api, app, config } from "../../app"
import utils from "../../utils"
import command from "./command"

class NList extends Component {
    constructor (props) {
        super(props)
        this.state = {
            dataList: [],
            detailInfo: {},
        }
    }

    /**
     * 表格行点击
     * @param record
     */
    handleRowClick = (record) => {
        this.setState({ detail_visible: true, detail_loading: true }, async () => {
            const params = {
                id: record.id,
                indexno: app.getData('indexno'),
                account: app.getData('account'),
            }
            let { flag, data, msg } = await app.post(api.MessagetDetails, params)
            if (this._isMounted) {
                if (flag !== 1) {
                    app.alert(msg, "error")
                    data = {}
                }
                this.setState({ detailInfo: data, detail_loading: false }, async () => {
                    await this.handleReadNotice(record.id)
                })
            }
        })
    }

    /**
     * 阅读通知
     * @param id
     */
    handleReadNotice = async (id) => {
        const params = {
            id,
            is_read: 1,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }
        let { flag, msg } = await app.post(api.MessagetRead, params)
        if (this._isMounted) {
            if (flag === 1) {
                this.dataSource()
                app.alert(msg, "info")
            } else {
                app.alert(msg, "error")
            }
        }
    }

    /**
     * 关闭详情
     */
    closeDetailModal = () => {
        this.setState({ detailInfo: {}, detail_loading: false, detail_visible: false })
    }

    componentDidMount () {
        this._isMounted = true
        this.dataSource()
    }

    componentWillUnmount () {
        this._isMounted = false
    }

    /**
     * 数据源
     */
    dataSource = () => {
        this.setState({ data_loading: true }, async () => {
            const params = {
                indexno: app.getData('indexno'),
                account: app.getData('account'),
            }
            let { flag, data, msg } = await app.post(api.MessagetList, params)
            if (this._isMounted) {
                if (flag !== 1) {
                    app.alert(msg, "error")
                    data = []
                }
                this.setState({ dataList: utils.addArrayKey(data), data_loading: false })
            }
        })
    }

    /**
     * 不再显示设置
     * @param id
     * @returns {Promise<void>}
     */
    handleNotShow = async (id) => {
        let flag = await command.hideMessageOrTrain(id, 'message')
        if (flag) {
            await this.dataSource()
        }
    }

    render () {
        const columns = [
                {
                    title: '阅读情况',
                    dataIndex: 'is_read',
                    key: 'is_read',
                    width: '15%',
                    render (text) {
                        let val = text === "1" ? "已阅读" : "未阅读"
                        return (<span>{val}</span>)
                    }
                },
                {
                    title: '标题',
                    dataIndex: 'title',
                    key: 'title',
                    width: '35%',
                    render: (text, record) => {
                        return (<div className="n-title-c" onClick={() => this.handleRowClick(record)}>{text}</div>)
                    },
                },
                {
                    title: '级别',
                    dataIndex: 'object',
                    key: 'object',
                    width: '10%'
                },
                {
                    title: '发布者',
                    dataIndex: 'vname',
                    key: 'vname',
                    width: '10%',
                },
                {
                    title: '日期',
                    dataIndex: 'cteate_time',
                    key: 'cteate_time',
                    width: '15%',
                },
                {
                    title: '操作',
                    dataIndex: 'id',
                    key: 'id',
                    width: '15%',
                    render: (id, { is_read }) => {
                        if (is_read === '1') {
                            return (
                                <Popconfirm title="确定不再显示吗？" onConfirm={() => this.handleNotShow(id)}>
                                    <Button size="small" disabled={is_read !== '1'} type="danger"
                                            icon="delete">不再显示</Button>
                                </Popconfirm>
                            )
                        } else {
                            return (
                                <Button size="small" disabled type="danger" icon="delete">不再显示</Button>
                            )
                        }
                    }
                },
            ],
            { dataList, data_loading, detail_loading, detailInfo, detail_visible } = this.state
        return (
            <div className="n-page notice-list">
                <div className="page-title">通知 <span
                    style={{ fontSize: 12, color: "#FF6600" }}>可以收到管理员发出的通知、新闻、超级管理员可以收到反馈的信息</span></div>
                <div className="page-content">
                    <Table
                        columns={columns}
                        locale={app.tbLocale(data_loading)}
                        loading={data_loading}
                        dataSource={dataList}
                        scroll={{ y: 'calc(100% - 38px)' }}
                        pagination={false}
                        size="small"
                        className="notice-table"
                    />
                    <Modal
                        visible={detail_visible}
                        onCancel={this.closeDetailModal}
                        footer={null}
                        title={<div style={{ textAlign: "center" }}>通知详情</div>}
                        destroyOnClose={true}
                        width='80%'
                        centered={true}
                        className="notice-list-detail"
                    >
                        {
                            detail_loading ? <div style={{ textAlign: "center" }}><Spin/></div> :
                                (
                                    <div className="items">
                                        <Row className="item">
                                            <Col span={4}>标题：</Col>
                                            <Col span={20}>{detailInfo.title}</Col>
                                        </Row>
                                        <Row className="item">
                                            <Col span={4}>通知级别：</Col>
                                            <Col span={20}>{detailInfo.object}</Col>
                                        </Row>
                                        <Row className="item">
                                            <Col span={4}>发布人：</Col>
                                            <Col span={20}>{detailInfo.vname}</Col>
                                        </Row>
                                        <Row className="item">
                                            <Col span={4}>发布时间：</Col>
                                            <Col span={20}>{detailInfo.cteate_time}</Col>
                                        </Row>
                                        <Row className="item">
                                            <Col span={4}>通知详情：</Col>
                                            <Col span={20}>
                                                <div className="braft-output-content"
                                                     dangerouslySetInnerHTML={{ __html: detailInfo.content }}/>
                                            </Col>
                                        </Row>
                                        {
                                            detailInfo.images && detailInfo.images.length ? (
                                                <Row className="item">
                                                    <Col span={20} offset={4}>
                                                        {
                                                            detailInfo.images.map((img, index) => {
                                                                img = config.imgUrl + img
                                                                return (<a key={index} href={img} target="_blank">
                                                                    <img className="d-img" src={img} alt="" key={index}/>
                                                                </a>)
                                                            })
                                                        }
                                                    </Col>
                                                </Row>
                                            ) : null
                                        }
                                    </div>
                                )
                        }
                    </Modal>
                </div>
            </div>
        )
    }
}

export default NList



// WEBPACK FOOTER //
// ./src/routes/notice/NList.jsx